import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";
import router from "@/router";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useSalariesList() {
  // Use toast
  const toast = useToast();

  const refSalaryListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "編號", sortable: true },
    { key: "expense", stickyColumn: true, label: "薪金支出", formatter: formatCurrency },
    // { key: "invoice", label: "發票編號" },
    { key: "prepayment", label: "預支", formatter: formatCurrency },
    { key: "salary_type", label: "薪資形式", sortable: true },
    { key: "year_month", label: "出糧月份", sortable: true },
    { key: "payment_date", label: "出糧日期", sortable: true },
    { key: "export", label: "列印" },
    { key: "user_id", label: "員工", sortable: true },
    { key: "show_details", label: "詳情" },
    // { key: "working_days", label: "工作天數" },
    // { key: "day_salary", label: "每日工資", formatter: formatCurrency },
    { key: "gross_salary", label: "應發工資", sortable: true, formatter: formatCurrency },
    { key: "actual_salary", label: "實發工資", sortable: true, formatter: formatCurrency },
    { key: "salary_receive_method_id", label: "收款方式", sortable: true },
    // { key: "expense.check_number", label: "支票號碼", sortable: true },
    // { key: "working_date", label: "工作日期", sortable: true },
    { key: "remark", label: "備註", sortable: true },
    // { key: "is_approved", label: "已審核", sortable: true },
    // { key: "is_rejected", label: "已拒絕" },
    // { key: "admin_remark", label: "管理員備註" },

  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("year_month");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refSalaryListTable.value
      ? refSalaryListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refSalaryListTable.value.refresh();
  };

  const salariesList = ref(null);


  const filter_date_from = ref(null);
  const filter_date_to = ref(null);

  const filter_user_id = ref(null);
  const filter_invoice_id = ref(null);
  const filter_salary_type = ref(null);
  watch(
    [
      currentPage,
      perPage, searchQuery,
      filter_user_id,
      filter_invoice_id,
      filter_salary_type,
      filter_date_from,
      filter_date_to
    ],
    () => {
      refetchData();
    }
  );

  const oneYear = new Date()
  oneYear.setFullYear(oneYear.getFullYear() + 1);
  const year = oneYear.getFullYear();
  const month = String(oneYear.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so we add 1
  const day = String(oneYear.getDate()).padStart(2, '0');

  // Format the date as "yyyy-mm-dd"
  const formattedDate = `${year}-${month}-${day}`;

  const getFormatedDate = (date) => {
    const mm = date.getMonth() + 1; // getMonth() is zero-based
    const dd = date.getDate();
    const hh = date.getHours();
    const ii = date.getMinutes();

    return [
      date.getFullYear(),
      (mm > 9 ? "" : "0") + mm,
      (dd > 9 ? "" : "0") + dd,
    ].join("-")
    // Don't delete this code (For UTC)
    //  + ' ' + [
    //   (hh > 9 ? "" : "0") + hh,
    //   (ii > 9 ? "" : "0") + ii,
    //   ].join(":");
  }

  const getStartTime = (date) => {
    if (date) {
      var start = new Date(date);
      // Don't delete this code (For UTC)
      start.setDate(start.getDate() - 1);
      // start.setHours(16);
      // start.setMinutes(0);
      // start.setSeconds(0); 
      return getFormatedDate(start);
    }
  }

  const getEndTime = (date) => {
    if (date) {
      var end = new Date(date);
      // end.setHours(16);
      // end.setMinutes(0);
      // end.setSeconds(0); 
      return getFormatedDate(end);
    }
  }
  const is_user_page = ref(false);
  const fetchSalaries = (ctx, callback) => {

    if (router.currentRoute.name == 'worker-salary-list') {
      is_user_page.value = true
    } else {
      is_user_page.value = false
    }
    // 只在初始載入時設置預設的 filter_user_id
    if (filter_user_id.value === null) {
      // 檢查用戶是否有管理員權限（與後端邏輯保持一致）
      const userData = JSON.parse(localStorage.getItem('userData'));
      const hasAdminPermission = ability.can('admin', 'user_salaries') && is_user_page.value ==  true ||
                                 ability.can('read', 'salaries') && is_user_page.value == false
      filter_user_id.value = hasAdminPermission ? -1 : userData.id;
    }
    const startTime = filter_date_from.value ? getStartTime(filter_date_from.value) : null;
    const endTime = filter_date_to.value ? getEndTime(filter_date_to.value) : null;

    const apiParams = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      user_id: filter_user_id.value === -1 ? -1 : filter_user_id.value,
      invoice_id: filter_invoice_id.value,
      salary_type: filter_salary_type.value,
      start_date: startTime,
      end_date: endTime
    };

    // 調試信息
    console.log('薪資記錄API調用參數:', {
      ...apiParams,
      '篩選模式': apiParams.user_id === -1 ? '查看所有用戶' : `查看用戶 ${apiParams.user_id}`
    });

    // 根據路由名稱決定使用哪個 API 端點
    const actionName = router.currentRoute.name === 'worker-salary-list'
      ? 'salary/fetchSelfSalaries'  // 員工查看自己的薪資記錄
      : 'salary/fetchSalaries';     // 管理員查看所有薪資記錄

    store
      .dispatch(actionName, apiParams)
      .then((response) => {
        const { salary_records, total } = response.data;

        // 新的 API 已經包含 salary_type 字段，不需要手動設置
        // 針對 payment_method_id = 3 (以工程項目計算) 的記錄：
        // - 每個 expense_id 現在作為獨立記錄回傳
        // - 每個記錄包含 expense_id 欄位用於識別
        // - 同一員工的不同 expense 會顯示為不同的列表項目

        callback(salary_records);
        totalRow.value = total;
        salariesList.value = salary_records
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const userOptions = ref([]);
  const invoiceOptions = ref([]);
  const expenseOptions = ref([]);
  const prepaymentOptions = ref([]);
  const claimOptions = ref([]);
  const productCategoriesOptions = ref([]);
  const salaryReceiveMethodOptions = ref([]);
  const refetchOption = () => {
    // 根據是否為員工頁面決定發票選項的獲取方式
    if (is_user_page.value) {
      // 員工頁面：分別獲取選項，發票選項使用專門的 API
      Promise.all([
        store.dispatch("app/fetchOptionList", {
          users: true,
          expenses: true,
          prepayments: true,
          claims: true,
          product_categories: true,
          receive_methods: true
        }),
        store.dispatch("salary/fetchSelfInvoices")
      ]).then(([optionResponse, invoiceResponse]) => {
        userOptions.value = optionResponse.data.users;
        invoiceOptions.value = invoiceResponse.data.invoices;
        expenseOptions.value = optionResponse.data.expenses;
        prepaymentOptions.value = optionResponse.data.prepayments;
        claimOptions.value = optionResponse.data.claims;
        productCategoriesOptions.value = optionResponse.data.product_categories;
        salaryReceiveMethodOptions.value = optionResponse.data.receive_methods.sort((a, b) => a.sort_order - b.sort_order);
      }).catch((error) => {
        console.error('獲取員工薪資選項時出錯:', error);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取選項清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
    } else {
      // 管理員頁面：使用原本的方式獲取所有選項
      store
        .dispatch("app/fetchOptionList", {
          users: true,
          invoices: true,
          expenses: true,
          prepayments: true,
          claims: true,
          product_categories: true,
          receive_methods: true
        })
        .then((response) => {
          userOptions.value = response.data.users;
          invoiceOptions.value = response.data.invoices;
          expenseOptions.value = response.data.expenses;
          prepaymentOptions.value = response.data.prepayments;
          claimOptions.value = response.data.claims;
          productCategoriesOptions.value = response.data.product_categories;
          salaryReceiveMethodOptions.value = response.data.receive_methods.sort((a, b) => a.sort_order - b.sort_order);
        }).catch((error) => {
          console.error('獲取管理員薪資選項時出錯:', error);
          toast({
            component: ToastificationContent,
            props: {
              title: "獲取選項清單時出錯",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    }
  };

  onMounted(() => {
    setTimeout(() => {
      refetchOption();
    }, 1000);
  });

  return {
    fetchSalaries,
    tableColumns,
    perPage,
    totalRow,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    salariesList,
    refSalaryListTable,
    ability,
    refetchData,
    userOptions,
    invoiceOptions,
    expenseOptions,
    prepaymentOptions,
    claimOptions,
    productCategoriesOptions,
    filter_user_id,
    filter_invoice_id,
    filter_salary_type,
    filter_date_from,
    filter_date_to,
    salaryReceiveMethodOptions,
    is_user_page,
  };
}
